import { render, staticRenderFns } from "./PlansBox.vue?vue&type=template&id=328b999d&scoped=true"
import script from "./PlansBox.vue?vue&type=script&lang=js"
export * from "./PlansBox.vue?vue&type=script&lang=js"
import style0 from "./PlansBox.vue?vue&type=style&index=0&id=328b999d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b999d",
  null
  
)

export default component.exports